import React from 'react';
import PropTypes from 'prop-types';
import {StyledDot} from './StyledDot';
import {colorsStyles} from '../../utils/styles';

const Dot = ({ color = colorsStyles.primary_5, ...rest }) => (
  <StyledDot color={color} {...rest} />
);

Dot.propTypes = {
  color: PropTypes.string,
};

export default Dot;
